import { Model, fk, many, attr } from "redux-orm";
import { NaeSSchemaMap } from "../../config/NaeSSchema";

class DriverTripModel extends Model {
  static reducer(action, DriverTripModel, session) {
    switch (action.type) {
      case "UPSERT_" + NaeSSchemaMap.DriverTrip.schema:
        action.payload.forEach((payload) => {
          const dbData = DriverTripModel.withId(payload.id);

          const upsertData = payload;
          if (dbData) {
            const keys = Object.keys(upsertData);
            let needChange = false;
            keys.map((key) => {
              if (
                JSON.stringify(upsertData[key]) !== JSON.stringify(dbData[key])
              ) {
                needChange = true;
              }
            });

            if (!needChange) {
              return;
            }
          }

          DriverTripModel.upsert(payload);
        });
        break;
    }
    // Return value is ignored.
    return session.state;
  }

  toString() {
    return this.id;
  }
  // Declare any static or instance methods you need.
}
DriverTripModel.modelName = "DriverTripModel";

DriverTripModel.fields = {
  id: attr(),
};

export default DriverTripModel;